var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('b-breadcrumb',{staticClass:"mt-3 mb-3",attrs:{"items":_vm.breadcrumb_items}}),_vm._v(" "),_c('b-row',{staticClass:"mt-3 mb-3",attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"right"}},[(
                        this.$route.params.user_id
                            ? _vm.$store.state.user_obj &&
                              _vm.checkPermission(
                                  _vm.$store.state.user_obj,
                                  'Account',
                                  'Client',
                                  'Edit',
                                  true
                              )
                            : _vm.$store.state.user_obj &&
                              _vm.checkPermission(
                                  _vm.$store.state.user_obj,
                                  'Account',
                                  'Client',
                                  'Create',
                                  true
                              )
                    )?_c('b-button',{staticClass:"btn-action",attrs:{"size":"sm","variant":"info"},on:{"click":function($event){return _vm.submitClientForm()}}},[_vm._v("Save")]):_vm._e()],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-1"},[_c('FormInput',{attrs:{"canEditFields":_vm.canEditFields,"validateState":_vm.validateState,"getErrorMessages":_vm.getErrorMessages,"data":_vm.cms_client_obj,"onChangeData":_vm.onChangeData}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3",attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"right"}},[(
                        this.$route.params.user_id
                            ? _vm.$store.state.user_obj &&
                              _vm.checkPermission(
                                  _vm.$store.state.user_obj,
                                  'Account',
                                  'Client',
                                  'Edit',
                                  true
                              )
                            : _vm.$store.state.user_obj &&
                              _vm.checkPermission(
                                  _vm.$store.state.user_obj,
                                  'Account',
                                  'Client',
                                  'Create',
                                  true
                              )
                    )?_c('b-button',{staticClass:"btn-action",attrs:{"size":"sm","variant":"info"},on:{"click":function($event){return _vm.submitClientForm()}}},[_vm._v("Save")]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-229fd957","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CmsClientForm.vue
// module id = null
// module chunks = 